<template>
  <!-- 表刷新、导出excel、列显隐筛选 -->
  <el-button-group class="refresh_export_hide" v-if="isShowRefresh">
    <el-tooltip effect="dark" content="点击刷新列表" placement="top-start">
      <el-button @click="refreshTable($event)" size="large"
        ><el-icon><RefreshRight /></el-icon>刷新</el-button
      >
    </el-tooltip>
    <el-tooltip
      effect="dark"
      content="点击导出当前列表数据(Excel格式)"
      placement="top-start"
    >
      <el-button @click="downloadExcel($event)" size="large"
        ><el-icon><Download /></el-icon>导出</el-button
      >
    </el-tooltip>
   
  <el-tooltip
        effect="dark"
        content="点击导出当前列表数据(Excel格式)"
        placement="top-start"
      >
    <el-popover placement="bottom" trigger="click">
      <template #reference>
        <el-button size="large">
          <el-icon><Filter /></el-icon> 设置
        </el-button>
      </template>
      <div class="column_checkbox">
        <el-checkbox-group
          v-model="visibleList"
          :min="1"
          @change="visibleListChange"
        >
          <el-checkbox
            v-for="(col, index) in columnList"
            :key="index"
            :label="col.label"
            :title="col.value"
            border
            >{{ col.value }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
    </el-popover>
    </el-tooltip>
  </el-button-group>
  <!-- 表格 -->
  <div>
    <el-table
      :id="componentTableId"
      class="table"
      v-loading="loading"
      :empty-text="emptyText"
      :element-loading-text="loadingText"
      ref="multipleTableRef"
      :data="tableData"
      :height="tableHeight"
      border
      :header-cell-style="{ background: '#f5f7fa' }"
      style="width: 100%; margin-top: 10px"
      :default-expand-all="defaultExpandAll"
      :row-key="getRowKeys"
      lazy
      :tree-props="{ children: 'children' }"
      @selection-change="handleSelectionChange"
    >
      <template v-for="(headItem, index) in headerData" :key="index">
        <template v-if="!curHideList[index]">
          <el-table-column
            :prop="headItem.prop"
            :label="headItem.label"
            :type="headItem.type"
            :width="headItem.width"
            :min-width="headItem.minwidth"
            :align="headItem.align"
            :fixed="headItem.fixed"
            :show-overflow-tooltip="
              headItem.noTooltip === undefined
                ? true
                : headItem.noTooltip === true
                ? true
                : false
            "
          >
            <!-- 表头 -->
            <template
              #header
              v-if="headItem.type && headItem.type !== 'selection'"
            >
              <el-popover placement="bottom" trigger="click">
                <template #reference>
                  <!-- 输入框搜索 -->
                  <div v-if="headItem.type == 'InputSearch'">
                    <span class="search-title">{{ headItem.label }}</span>
                    <el-icon><Search /></el-icon>
                  </div>
                  <!-- 下拉框搜索 -->
                  <div v-if="headItem.type == 'SelectSearch'">
                    <span class="search-title">{{ headItem.label }}</span>
                    <el-icon><ArrowDown /></el-icon>
                  </div>
                  <!-- 级联选择器 -->
                  <div v-if="headItem.type == 'Cascader'">
                    <span class="search-title">{{ headItem.label }}</span>
                    <el-icon><ArrowDown /></el-icon>
                  </div>
                  <!-- 下拉框和输入框搜索联合 -->
                  <div v-if="headItem.type == 'SelectInputSearch'">
                    <span class="search-title">{{ headItem.label }}</span>
                    <el-icon><ArrowDown /></el-icon>
                  </div>
                  <!-- 时间选择器 -->
                  <div v-if="headItem.type == 'DatePicker'">
                    <span class="search-title">{{ headItem.label }}</span>
                    <el-icon><Search /></el-icon>
                  </div>
                  <!-- 时间选择器分开 -->
                  <div v-if="headItem.type == 'DateTime'">
                    <span class="search-title">{{ headItem.label }}</span>
                    <el-icon><Search /></el-icon>
                  </div>
                </template>
                <!-- 输入框搜索popover -->
                <el-input
                  v-if="headItem.type == 'InputSearch'"
                  v-model="headItem[headItem.prop]"
                  class="m-2"
                  :placeholder="'请输入' + headItem.label + '搜索'"
                  size="large"
                  clearable
                  @clear="
                    searchFnc({
                      prop: headItem.prop,
                      value: headItem[headItem.prop],
                      type: 'text',
                    })
                  "
                >
                  <template #suffix>
                    <el-icon
                      @click="
                        searchFnc({
                          prop: headItem.prop,
                          value: headItem[headItem.prop],
                          type: 'text',
                        })
                      "
                      clearable
                      ><Search
                    /></el-icon>
                  </template>
                </el-input>
                <!-- 下拉框搜索popover-->
                <el-select
                  v-if="headItem.type == 'SelectSearch'"
                  v-model="headItem[headItem.prop]"
                  class="m-2 select_width"
                  :placeholder="
                    headItem.placeholder
                      ? headItem.placeholder
                      : '请选择' + headItem.label
                  "
                  size="large"
                  clearable
                  :filterable="headItem.selectOptions&&headItem.selectOptions.length>=10
                      ? true
                      : false
                    "
                  @change="
                    searchFnc({
                      prop: headItem.prop,
                      value: headItem[headItem.prop],
                      type: 'text',
                    })
                  "
                >
                  <el-option
                    v-for="item in headItem.selectOptions"
                    :key="
                      item.key != null || item.key != undefined
                        ? item.key
                        : item.id != null || item.id != undefined
                        ? item.id
                        : item
                    "
                    :label="
                      item.value != null || item.value != undefined
                        ? item.value
                        : item.name != null || item.name != undefined
                        ? item.name
                        : item
                    "
                    :value="
                      item.key != null || item.key != undefined
                        ? item.key
                        : item.id != null || item.id != undefined
                        ? item.id
                        : item
                    "
                  />
                </el-select>
                <!-- 级联选择器popover -->
                <el-cascader
                  v-if="headItem.type == 'Cascader'"
                  style="width: 270px"
                  ref="cascaderRef"
                  :options="headItem.cascaderOptions"
                  :props="props"
                  @change="changeCascader"
                  :placeholder="
                    headItem.placeholder
                      ? headItem.placeholder
                      : '请选择' + headItem.label
                  "
                  clearable
                  popper-class="cascader"
                />
                <!-- 下拉框和输入框搜索联合popover-->
                <el-row :span="24" v-if="headItem.type == 'SelectInputSearch'">
                  <el-col :span="12">
                    <el-select
                      :teleported="false"
                      style="width: 200px"
                      v-model="selectType"
                      class="m-2"
                      :placeholder="
                        headItem.placeholder
                          ? headItem.placeholder
                          : '请选择' + headItem.selectPlaceholder
                      "
                      size="large"
                      clearable
                      @change="changeRelevanceType"
                    >
                      <el-option
                        @click="changeRelevanceType"
                        v-for="item in headItem.selectOptions"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key"
                      />
                    </el-select>
                  </el-col>
                  <el-col :span="12" v-if="inputFiltrate">
                    <el-tooltip
                      :content="
                        '请先选择' +
                        headItem.selectPlaceholder +
                        '，再进行' +
                        headItem.inputPlaceholder +
                        '搜索'
                      "
                      placement="top"
                    >
                      <el-input
                        style="width: 200px"
                        v-model="keyword"
                        class="m-2"
                        :placeholder="
                          headItem.placeholder
                            ? headItem.placeholder
                            : '请输入' + headItem.inputPlaceholder + '搜索'
                        "
                        size="large"
                        clearable
                        @clear="relevanceSearch"
                      >
                        <template #suffix>
                          <el-icon @click="relevanceSearch" clearable
                            ><Search
                          /></el-icon>
                        </template>
                      </el-input>
                    </el-tooltip>
                  </el-col>
                </el-row>
                <!-- 时间选择器 开始时间-结束时间 popover-->
                <el-date-picker
                  v-if="headItem.type == 'DatePicker'"
                  style="width: 275px"
                  :append-to-body="false"
                  v-model="time"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="起始时间"
                  end-placeholder="结束时间"
                  @change="changeTime()"
                  @blur="blur"
                />
                <!-- 分开时间 -->
                 <div v-if="headItem.type == 'DateTime'" style="display:flex;align-items:center;">
                  <el-date-picker
                    v-model="time1"
                    type="datetime"
                    placeholder="选择开始日期时间"
                    size="large"
                    format="YYYY-MM-DD HH:mm:ss"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    @change="changeTimeStart()"
                    :disabled-date="disabledDateStart"
                    :teleported="false"
                  />
                  <span style="margin-right: 5px">至</span>
                  <el-date-picker
                    v-model="time2"
                    type="datetime"
                    placeholder="选择结束日期时间"
                    size="large"
                    :disabled-date="disabledDateEnd"
                    format="YYYY-MM-DD HH:mm:ss"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    @change="changeTimeEnd()"
                    :teleported="false"
                  />
                </div>
              </el-popover>
            </template>

            <!-- 表格行内容 -->
            <template
              #default="{ row, $index }"
              v-if="headItem.type !== 'selection'"
            >
              <!-- 有单位的普通数据 -->
              <span v-if="headItem.unit && row[headItem.prop]"
                >{{ row[headItem.prop] }}{{ headItem.unit }}</span
              >
              <!-- 链接跳转 -->
              <span v-if="headItem.linkJump && row[headItem.prop]">
                <a
                  class="blue hand"
                  :href="row[headItem.prop]"
                  target="_blank"
                  v-if="row[headItem.prop]"
                  >{{ row[headItem.prop] }}</a
                >
                <span class="gray" v-else>未设置</span>
              </span>
              <!-- 单元格无数据 -->
              <span
                v-if="
                  (isNull(row[headItem.prop]) && !headItem.operation) ||
                  row[headItem.prop] == '未设置'
                "
                class="gray"
                >{{ headItem.noSetText ? headItem.noSetText : "未设置" }}</span
              >
              <!-- 图片预览 -->
              <span
                v-else-if="headItem.isImg && row[headItem.prop]"
                class="demo-image__preview"
              >
                <el-image
                  style="width: 20px; height: 20px; border: 1px solid #dcdfe6"
                  :src="row[headItem.prop]"
                  :preview-src-list="[row[headItem.prop]]"
                  fit="cover"
                  close-on-press-escape
                  hide-on-click-modal
                />
              </span>
              <!-- v-html内容过多 查看详情 -->
              <span
                class="hand blue"
                v-else-if="headItem.isToMoreContents && row[headItem.prop]"
                @click="
                  openContent({
                    prop: headItem.prop,
                    value: row,
                  })
                "
              >
                {{ headItem.showSelf ? row[headItem.prop] : "查看详情" }}</span
              >
              <!-- 数组标签 -->
              <span v-else-if="headItem.isTagArr && row[headItem.prop]">
                <span v-if="row[headItem.prop].length > 0">
                  <el-tag v-for="tag in row[headItem.prop]" :key="tag">{{
                    tag
                  }}</el-tag>
                </span>
              </span>
              <!-- 是(蓝色)否(红色)标签  -->
              <span v-else-if="headItem.isTag">
                <el-tag
                  :type="row[headItem.prop] ? '' : 'danger'"
                  size="large"
                  effect="dark"
                >
                  {{ row[headItem.prop] ? "是" : "否" }}
                </el-tag>
              </span>
              <!-- 自定义插槽 -->
              <slot
                v-else-if="headItem.custom"
                :name="headItem.prop + 'Custom'"
                :scope="row"
                :index="$index"
              ></slot>
              <!-- 自定义操作按钮 -->
              <span v-else-if="headItem.operation">
                <el-button
                  v-if="headItem.edit"
                  type="primary"
                  size="default"
                  plain
                  @click="handleScope($event, row, 'edit')"
                  >编辑</el-button
                >
                <el-button
                  v-if="headItem.delete"
                  type="danger"
                  size="default"
                  plain
                  @click="handleScope($event, row, 'delete')"
                  >删除</el-button
                ></span
              >
            </template>
          </el-table-column>
        </template>
      </template>
    </el-table>
  </div>
</template>

<script>
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { lostFocus, formattingDate,timeFormatNew } from "common/utils";
import {
  reactive,
  onMounted,
  toRefs,
  computed,
  toRaw,
  ref,
  unref,
  getCurrentInstance,
  watch,
} from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
export default {
  components: {},
  props: {
    isShowRefresh:{
  type: Boolean,
      default:true,
    },
    tableHeight: Number,
    //表格数据
    tableData: Array,
    //表头数据
    headerData: Array,
    //导出的Excel名称
    excelName: String,
    //需要导出的表格Table ID 唯一性
    componentTableId: String,
    hideColumnIndexs: {
      //需要隐藏的列的下标即表格数据的序号从0开始
      type: Array,
      default: (_) => [],
    },
    emptyText: {
      type: String,
      default: "暂无数据",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loadingText: {
      type: String,
      default: "loading",
    },
    // 是否默认展开所有行，当 Table 包含展开行存在或者为树形表格时有效
    defaultExpandAll: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    "open-content": null,
    "update-list": null,
    "edit-fnc": null,
    "delete-fnc": null,
    "search-fnc": null,
    "hide-column": null,
    "get-table-column": null,
    "handle-selection": null,
    "change-cascader": null,
    "change-relevance": null,
    "change-time": null,
  },
  setup(props, { emit }) {
    const data = reactive({
      visibleList: [], //显示/隐藏列的选中下标数据集合
      columnList: [], //表格所有列名称数据列表
      curHideList: [], //隐藏列
      input: "", //input筛选
      value: "", //select筛选
      multipleSelection: [], //选中行数据
      // cascader级联属性
      props: {
        expandTrigger: "hover",
        checkStrictly: true,
        value: "id",
        label: "name",
        children: "children",
      },
      categoryOneId: "", //级联一级筛选
      categoryId: "", //级联二级筛选
      selectType: null, //关联类别筛选
      keyword: null, //关联-关键字筛选
      inputFiltrate: false, //input筛选禁用
      time: "", //时间选择器
      time1: "", //时间选择器分开
      time2: "", //时间选择器分开
      startTime: "",
      endTime: "",
      defaultTime1: new Date(2000, 1, 1, 0, 0, 0),
      defaultTime2: new Date(2000, 1, 1, 23, 59, 59),
      // 开始起始点禁用日期筛选
      pickerOptionsStart: {
                disabledDate: (time) => {
                    if (!this.liveForm.endTimeShow) {
                        return false;
                    }
                    return (
                        time.getTime() > new Date(this.liveForm.endTimeShow).getTime() ||
                        time.getTime() <
                        new Date(
                            `"${this.liveForm.endTimeShow.slice(0, this.liveForm.endTimeShow.length - 2)}01"`
                        ).getTime()
                    );
                },
            },
            // 开始结束点禁用日期筛选
            pickerOptionsEnd: {
                disabledDate: (time) => {
                    if (!this.liveForm.startTimeShow) {
                        return false;
                    }
                    // 判断当前日期所在月份有多少天
                    const getDuration = (preDate) => {
                        const date = new Date(preDate);
                        const year = date.getFullYear();
                        const month = date.getMonth() + 1;
                        const d = new Date(year, month, 0);
                        return d.getDate();
                    };
                    return (
                        time.getTime() < new Date(this.liveForm.startTimeShow).getTime() - 8.64e7 ||
                        time.getTime() >
                        new Date(
                            `"${this.liveForm.startTimeShow.slice(
                                0,
                                this.liveForm.startTimeShow.length - 2
                            )}${getDuration(this.liveForm.startTimeShow)}"`
                        ).getTime()
                    );
                },
            },
    });

    //挂载后调用函数获取项目数据
    onMounted(() => {
      props.headerData.map((obj, index) => {
        if (obj.label) {
          data.columnList.push({
            label: index,
            value: obj.type == "selection" ? "选择" : obj.label,
          });
          // 记录初始展示的列
          if (props.hideColumnIndexs.indexOf(index) === -1) {
            data.visibleList.push(index);
            data.curHideList[index] = false;
          } else {
            data.curHideList.push(true);
          }
        }
      });
    });

    //树形结构row-key
    const getRowKeys = (row) => {
      return row.id;
    };

    //刷新-表格
    const refreshTable = (e) => {
      // 强制移除按钮焦点
      lostFocus(e);
      //直接执行父组件中的更新列表方法
      emit("update-list");
    };

    //导出-Excel
    const downloadExcel = (e) => {
      // 强制移除按钮焦点
      lostFocus(e);
      if (props.componentTableId == "")
        ElMessage.warning("页面表格ID不能为空!");
      let talbleId = "#" + props.componentTableId;
      // table要导出的是哪一个表格
      let table = document.querySelector(talbleId).cloneNode(true);
      var dropdownObj = table.querySelector(".el-select-dropdown__wrap");
      //表头是否有下拉框
      if (dropdownObj)
        //删掉table表头的下拉框，不然导出的Excel的表头会把下拉框里所有的值带上
        dropdownObj.parentNode.removeChild(dropdownObj);
      // 因为element-ui的表格的fixed属性导致多出一个table，会下载重复内容，这里删除掉
      var fixedObj = table.querySelector(".el-table__fixed");
      if (fixedObj) {
        var fa = fixedObj.parentNode;
        fa.removeChild(fixedObj);
      }
      let wb = XLSX.utils.table_to_book(table, { raw: true }); //获取表格数据
      let etout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          new Blob([etout], {
            type: "application/octet-stream",
          }),
          props.excelName + ".xlsx"
        ); //props.excelName.xlsx 为导出的文件名
      } catch (e) {
        console.log(e, etout);
      }
      return etout;
    };

    // 设置-列显示与隐藏
    const visibleListChange = (headItem) => {
      data.columnList.forEach((obj, index) => {
        data.curHideList[index] = false;
        // 更改显示隐藏列
        if (headItem.indexOf(index) === -1) {
          data.curHideList[index] = true;
        }
      });
    };

    // 判断是否是有效数据
    const isNull = (obj) => {
      if (
        obj === "" ||
        obj === 0 ||
        obj === undefined ||
        obj === null ||
        obj === "undefined" ||
        obj === "null" ||
        obj.length === 0 ||
        obj === "00000000-0000-0000-0000-000000000000"
      ) {
        return true;
      }
      return false;
    };

    //查看详情
    const openContent = (val) => {
      emit("open-content", val);
    };

    // 点击表格内操作模块 编辑 删除
    const handleScope = (e, row, type) => {
      // 强制去掉按钮focus
      lostFocus(e);
      if (type == "edit") {
        emit("edit-fnc", row);
      }
      if (type == "delete") {
        emit("delete-fnc", row);
      }
    };

    // 搜索
    const searchFnc = (val) => {
      emit("search-fnc", val);
    };

    // 表格多选行处理
    const handleSelectionChange = (row) => {
      data.multipleSelection = JSON.parse(JSON.stringify(row));
      emit("handle-selection", data.multipleSelection);
    };

    //级联选择器选择数据
    const cascaderRef = ref();
    const changeCascader = () => {
      // 目的是选择之后将下拉界面收起
      cascaderRef.value[0].togglePopperVisible();
      let nodesInfo = cascaderRef.value[0].getCheckedNodes();
      if (nodesInfo && nodesInfo[0]) {
        if (nodesInfo[0].level == 1) {
          //父级
          data.categoryOneId = nodesInfo[0].value;
        }
        if (nodesInfo[0].level == 2) {
          //子级
          data.categoryId = nodesInfo[0].value;
        }
      } else {
        data.categoryOneId = null;
        data.categoryId = null;
        cascaderRef.value[0].togglePopperVisible();
      }
      emit("change-cascader", {
        categoryOneId: data.categoryOneId,
        categoryId: data.categoryId,
      });
    };

    //选择关联类别（选择关联类别后不会传递参数给父组件，搜索关键字的时候一同传递）
    const changeRelevanceType = () => {
      data.keyword = "";
      if (
        data.selectType == 1 ||
        data.selectType == 2 ||
        data.selectType == 3
      ) {
        data.inputFiltrate = true;
      } else {
        data.selectType = null;
        data.inputFiltrate = false;
      }
    };

    //关联搜索-关键字
    const relevanceSearch = () => {
      emit("change-relevance", {
        type: data.selectType,
        keyword: data.keyword,
      });
    };

    //选择时间 -筛选
    const changeTime = () => {
      if (data.time) {
        data.startTime = formattingDate(data.time[0], "yyyy-MM-dd hh:mm");
        data.endTime = formattingDate(data.time[1], "yyyy-MM-dd hh:mm");
        emit("change-time", {
          startTime: data.startTime,
          endTime: data.endTime,
        });
      } else {
        data.startTime = null;
        data.endTime = null;
        emit("change-time", {
          startTime: data.startTime,
          endTime: data.endTime,
        });
      }
    };
    const dateVal = (date) => {
    return Date.parse(new Date(date));
  };
     // 开始日期限制
  const disabledDateStart = (time) => {
    if (data.time2) {
      return time.getTime() > dateVal(data.time2);
    }
  };
  // 结束日期限制
  const disabledDateEnd = (time) => {
    if (data.time1) {
      return time.getTime() < dateVal(data.time1);
    }
  };
    //选择时间开始 -筛选
    const changeTimeStart = () => {
      if (data.time1) {
        data.startTime = timeFormatNew(data.time1, "yyyy-MM-dd hh:mm:ss");
        emit("change-time-start", {
          startTime: data.startTime,
        });
      } else {
        data.startTime = null;
        emit("change-time-start", {
          startTime: data.startTime,
        });
      }
    };
    //选择时间结束 -筛选
    const changeTimeEnd = () => {
      if (data.time2) {
        data.endTime = timeFormatNew(data.time2, "yyyy-MM-dd hh:mm:ss");
        emit("change-time-end", {
          endTime: data.endTime,
        });
      } else {
        data.endTime = null;
        emit("change-time-end", {
          endTime: data.endTime,
        });
      }
    };
    return {
      ...toRefs(data),
      getRowKeys,
      refreshTable,
      downloadExcel,
      handleScope,
      isNull,
      visibleListChange,
      openContent,
      searchFnc,
      handleSelectionChange,
      cascaderRef,
      changeCascader,
      changeRelevanceType,
      relevanceSearch,
      changeTime,
      changeTimeStart,
      changeTimeEnd,
      disabledDateStart,
      disabledDateEnd,
    };
  },
};
</script>


<style scoped>
.refresh_export_hide {
  position: absolute;
  top: 15px;
  right: 12px;
  margin-right: 10px;
}

.column_checkbox {
  width: 400px;
}
.column_checkbox >>> .el-checkbox {
  width: 45%;
  margin-bottom: 20px;
  margin-right: 10px;
}
.column_checkbox >>> .el-checkbox__label {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.select_width {
  width: 276px;
}
</style>
<style >
.el-popper {
  max-width: 450px !important;
 
}
/* 此样式解决树形结构的下级id不展示问题 */
.el-table__placeholder {
  display: inline !important;
}

.el-cascader-panel .el-radio {
  width: 100%;
  height: 100%;
  z-index: 10;
  position: absolute;
  top: 10px;
  right: 10px;
}
.el-cascader-panel .el-radio__input {
  visibility: hidden;
}
.el-cascader-panel .el-cascader-node__postfix {
  top: 10px;
}
.el-cascader-node.is-selectable.in-active-path {
  color: #409eff;
}
.el-popper {
  width: auto !important;
}
.el-popper .el-icon {
  cursor: pointer;
}


</style>